import React, { useState } from 'react'
import { Box, Typography, Stack } from '@mui/material'
import { BreakdownDialog } from './BreakdownDialog'
import { BreakdownButton } from './BreakdownButton'
import { DetailRow } from './DetailRow'

export const PointBreakdown = ({ pointBreakdown = [] }) => {
  const [modalOpen, setModalOpen] = useState(false)
  const [activeItem, setActiveItem] = useState(null)

  const openBreakdown = (item) => {
    setActiveItem(item)
    setModalOpen(true)
  }

  const closeBreakdown = () => {
    setModalOpen(false)
    setActiveItem(null)
  }

  return (
    <>
      <Stack spacing={0.75} sx={{ my: 0.25, minWidth: 220 }}>
        {pointBreakdown.map((item) => (
          <BreakdownButton
            key={item.htgCompany}
            value={`${item.companyAccountId} • ${item.htgCompany}`}
            label={`Breakdown for ${item.companyAccountId}`}
            onClick={() => openBreakdown(item)}
          />
        ))}
      </Stack>
      <BreakdownDialog open={modalOpen} title='Breakdown' onClose={closeBreakdown}>
        {!activeItem && (
          <Typography variant='body2' sx={{ opacity: 0.7 }}>
            No breakdown data available.
          </Typography>
        )}
        {activeItem && (
          <Box sx={{ mb: 1.5 }}>
            <DetailRow label='HTG Company' value={activeItem.htgCompany} />
            <DetailRow label='Company ID' value={activeItem.companyAccountId} />
            <DetailRow label='Company Name' value={activeItem.companyName} />
            <DetailRow label='Sales' value={activeItem.salesId} />
            <DetailRow label='Point' value={activeItem.point} />
          </Box>
        )}
      </BreakdownDialog>
    </>
  )
}
